import { render, staticRenderFns } from "./ModalCreateArticle.vue?vue&type=template&id=76fb4f30"
import script from "./ModalCreateArticle.vue?vue&type=script&lang=js"
export * from "./ModalCreateArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports